/* Product-page shipping note. Shows a short note on sizes with a shipping restriction,
   such as "Ships to Florida only". It never hides a button and needs no location:
   checkout enforces the real rules, so any failure here just shows no note.
   The wording and rules come from the Everglades rate service.
   Source: shipping-restrictions-shopify/theme/. */
(function () {
  const API = 'https://rates.everglades.farm/notes';
  const data = document.querySelector('script[data-variant-state]');
  if (!data || window.evgNotesLoaded) return;
  window.evgNotesLoaded = true;
  const ids = JSON.parse(data.textContent).variants.map(function (variant) { return variant.id; });
  if (!ids.length) return;

  let notes = null;

  function selectedVariant() {
    const input = document.querySelector('form[action*="/cart/add"].form input.product-variant-id');
    return input ? input.value : String(ids[0]);
  }

  function noteElement() {
    let note = document.getElementById('evg-shipping-note');
    if (note) return note;
    const picker = document.querySelector('variant-selects, variant-radios');
    const buttons = document.querySelector('form[action*="/cart/add"].form .product-form__buttons');
    if (!picker && !buttons) return null;
    note = document.createElement('p');
    note.id = 'evg-shipping-note';
    note.style.cssText = 'margin:1rem 0;padding:0.9rem 1.4rem;border-left:4px solid #f04e00;border-radius:8px;'
      + 'background:#fdeee6;color:#8f2f00;font-size:1.6rem;font-weight:700;letter-spacing:0.02rem;line-height:1.4;';
    if (picker) picker.after(note);
    else buttons.parentNode.insertBefore(note, buttons);
    return note;
  }

  function render() {
    if (!notes) return;
    const text = notes[selectedVariant()];
    const note = text ? noteElement() : document.getElementById('evg-shipping-note');
    if (!note) return;
    note.textContent = text || '';
    note.style.display = text ? '' : 'none';
  }

  async function load() {
    try {
      const response = await fetch(API + '?variants=' + ids.join(','));
      if (!response.ok) return;
      notes = (await response.json()).notes;
      render();
    } catch (e) { /* no note; checkout still enforces */ }
  }

  document.addEventListener('change', function (event) {
    if (event.target.closest('variant-selects, variant-radios')) setTimeout(render, 300);
  });
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
    subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(render, 0); });
  }
  load();
})();
